import "core-js/modules/es.array.fill.js";
export var fileUploaderPortalTokens = {
  baseBorderColor: function baseBorderColor(_ref) {
    var palette = _ref.palette;
    return palette.transparent;
  },
  baseBackgroundColor: function baseBackgroundColor(_ref2) {
    var palette = _ref2.palette;
    return palette.neutralsBlack.hex5;
  },
  hoverBackgroundColor: function hoverBackgroundColor(_ref3) {
    var palette = _ref3.palette;
    return palette.neutralsBlack.hex10;
  },
  dragAcceptBorderColor: function dragAcceptBorderColor(_ref4) {
    var palette = _ref4.palette;
    return palette.neutralsBlack.hex30;
  },
  dragRejectBorderColor: function dragRejectBorderColor(_ref5) {
    var palette = _ref5.palette;
    return palette.newRed.hex100;
  },
  dragActiveBorderColor: function dragActiveBorderColor(_ref6) {
    var palette = _ref6.palette;
    return palette.neutralsBlack.hex30;
  },
  disabledBorderColor: function disabledBorderColor(_ref7) {
    var palette = _ref7.palette;
    return palette.transparent;
  },
  disabledBackgroundColor: function disabledBackgroundColor(_ref8) {
    var palette = _ref8.palette;
    return palette.neutralsBlack.hex5;
  },
  itemErrorColor: function itemErrorColor(_ref9) {
    var color = _ref9.color;
    return color.importance.danger.base;
  },
  itemProgressWrapperBackgroundColor: function itemProgressWrapperBackgroundColor(_ref10) {
    var palette = _ref10.palette;
    return palette.neutralsBlack.rgba5;
  },
  itemProgressContentBackgroundColor: function itemProgressContentBackgroundColor(_ref11) {
    var color = _ref11.color;
    return color.importance.primary.base;
  },
  removeButtonColor: function removeButtonColor(_ref12) {
    var color = _ref12.color;
    return color.fill.icon.base;
  },
  removeButtonHoverColor: function removeButtonHoverColor(_ref13) {
    var color = _ref13.color;
    return color.fill.icon.hover;
  }
};